import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Checkbox } from "@/components/ui/checkbox";
import { EmployeeFormValues } from "../schemas/employeeFormSchema";

interface BilingualFormProps {
  control: Control<EmployeeFormValues>;
}

export const BilingualForm = ({ control }: BilingualFormProps) => {
  return (
    <div className="p-6 border-b">
      <h3 className="text-lg font-semibold mb-4">Language Skills</h3>
      <div className="space-y-4">
        <FormField
          control={control}
          name="bilingual"
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0 py-2">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <FormLabel className="font-normal">
                Bilingual (Speaks multiple languages)
              </FormLabel>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
